import { Modal, ModalActionButtonProps } from "@msys/ui";
import { useTheme } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { isEqual } from "lodash-es";
import React from "react";
import {
  ProductSearchContent,
  ProductSearchContentProps,
} from "../components/ProductSearchContent.js";
import { ProductFiltersFormValues } from "../filters/ProductFilterFields.js";

interface Props extends Omit<ProductSearchContentProps, "onFiltersChange"> {
  handleCancel?: () => void;
  cancelTitle?: string;
  handleFiltersSave?: (values: ProductFiltersFormValues) => Promise<unknown>;
  title?: string;
}

export const ProductSearchModal = ({
  handleClose,
  handleCancel,
  cancelTitle,
  handleFiltersSave,
  title,
  ...contentProps
}: Props) => {
  const { t } = useTranslate(["Product", "Global", "ProductSearch"]);
  const theme = useTheme();

  const [filters, setFilters] = React.useState<ProductFiltersFormValues | null>(
    null
  );

  const actionButtons: ModalActionButtonProps[] = [
    {
      label:
        cancelTitle ??
        t("Cancel", {
          ns: "Global",
        }),
      handleClick: () => {
        handleCancel?.();
        handleClose();
      },
      buttonProps: { variant: "text" },
    },
  ];
  if (handleFiltersSave) {
    actionButtons.push({
      label: t("Save filters", { ns: "ProductSearch" }),
      handleClick: () => {
        if (!filters) return;
        handleFiltersSave(filters);
        handleClose();
      },
      buttonProps: {
        variant: "contained",
        disabled:
          !filters?.productTypeIds ||
          filters.productTypeIds.length === 0 ||
          isEqual(filters, contentProps.initialFilters),
      },
    });
  }

  return (
    <Modal
      maxWidth="xl"
      dialogProps={{
        slotProps: { paper: { style: { height: "100%" } } },
      }}
      handleClose={handleClose}
      title={
        title ??
        t("Search Products", {
          ns: "ProductSearch",
        })
      }
      actionButtons={actionButtons}
      alwaysVisible
      titleProps={{
        sx: {
          position: "relative",
          zIndex: 2,
          backgroundColor: theme.palette.common.white,
        },
      }}
    >
      <ProductSearchContent
        {...contentProps}
        handleClose={handleClose}
        onFiltersChange={setFilters}
      />
    </Modal>
  );
};
